import { get, post, remove } from './api';
import routes from './end-points';

export const adminFundsApi = {
  init: () => get(routes.adminfunds.initFunds),
  saveChanges: (dto) => post(routes.adminfunds.applyFund, dto),
  delete: (fundId) => remove(routes.adminfunds.deleteFund(fundId)),
};
